import { BDiseaseCard } from '@pharmsnap/shared/components'
import { defineComponent, PropType } from '@vue/composition-api'

export const BDiseaseFetchCard = defineComponent({
  name: 'BDiseaseFetchCard',
  props: {
    id: {
      type: String,
      required: true,
    },
    drug_id: {
      type: String,
    },
    width: {
      type: Number,
      default: 360,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: 'horizontal',
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {}
  },
  render() {
    return (
      <BDiseaseCard
        style={{ width: `${this.width}px` }}
        id={this.id}
        drug_id={this.drug_id}
        direction={this.direction}
        border={this.border}
        onLoaded={() => this.$emit('loaded')}
      ></BDiseaseCard>
    )
  },
})
